import styled from 'styled-components'

import type { ButtonTheme } from '@/@bothrs-theme/types/button-theme'
import type { ButtonProps } from './Button.types'

const StButton = styled.button<Pick<ButtonProps, 'variant' | 'size' | 'inline' | 'noWrap' | 'disabled' | 'isLoading'>>`
  width: ${({ inline }) => (inline ? 'auto' : '100%')};
  min-height: ${({ size, theme }) => (size === 'small' ? theme.UI.SpacingPx.Space6 : theme.UI.SpacingPx.Space12)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: ${({ disabled, isLoading }) => (isLoading ? 'progress' : disabled ? `not-allowed` : 'pointer')};
  appearance: button;
  outline: none;
  user-select: none;

  ${({ noWrap }) => noWrap && `white-space: nowrap;`}

  ${({ theme, variant, size }) => {
    const buttonTheme = theme.Components.Button[variant] as ButtonTheme

    return `
      color: ${buttonTheme.Text};
      background-color: ${buttonTheme.Fill};
      border: 1px solid ${buttonTheme.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;

      padding: ${
        variant.startsWith('Tertiary')
          ? theme.UI.SpacingPx.Space1
          : size === 'small'
            ? theme.UI.SpacingPx.Space1
            : theme.UI.SpacingPx.Space3
      } ${
        variant.startsWith('Tertiary')
          ? '0px'
          : size === 'small'
            ? theme.UI.SpacingPx.Space2
            : theme.UI.SpacingPx.Space6
      };

      transition: all 250ms ease-out;

      &:hover {
        color: ${buttonTheme.ActiveText};
        background-color: ${buttonTheme.ActiveFill};
      }

      &:active {
        color: ${buttonTheme.ActiveText};
        background-color: ${buttonTheme.ActiveFill};
        border: 1px solid ${buttonTheme.ActiveBorder};
      }

      &:disabled {
        color: ${buttonTheme.DisabledText};
        background-color: ${buttonTheme.DisabledFill};
        border: 1px solid ${buttonTheme.DisabledBorder};
      }
    `
  }}

  > svg + span {
    margin-left: ${({ theme }) => theme.UI.SpacingPx.Space2};
  }

  > span + svg {
    margin-left: ${({ theme }) => theme.UI.SpacingPx.Space2};
  }
`

export { StButton }
